import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Button } from "../ui";
import { SiteHeader, SmartLink } from "../Landing/site/SiteHeader";
import { AUDIENCE_LINKS, SUPPORT_PHONE, type SiteNavItem } from "../Landing/site/siteConfig";

const INFO_NAV: SiteNavItem[] = [
  { label: "For you", children: AUDIENCE_LINKS },
  { label: "Our difference", href: "/info/our-difference" },
  { label: "FAQs", href: "/info/faqs" },
  { label: "About us", href: "/info/about-us" },
];

/** Navigation for the /info/* guides */
const InfoNavbar = () => (
  <SiteHeader
    nav={INFO_NAV}
    utility={
      <SmartLink
        href={SUPPORT_PHONE.href}
        className="tabular mr-2 inline-flex items-center gap-1.5 text-meta font-medium text-gray-500 transition-colors hover:text-gray-900"
      >
        <Phone className="size-3.5" />
        {SUPPORT_PHONE.display}
      </SmartLink>
    }
    actions={
      <>
        <Button variant="ghost" asChild>
          <Link to="/signin">Log in</Link>
        </Button>
        <Button variant="brand" asChild>
          <Link to="/get-started">Get started</Link>
        </Button>
      </>
    }
    mobileActions={
      <>
        <Button variant="brand" size="lg" asChild>
          <Link to="/get-started">Get started</Link>
        </Button>
        <Button variant="secondary" size="lg" asChild>
          <Link to="/signin">Log in</Link>
        </Button>
        <Button variant="ghost" size="lg" asChild>
          <a href={SUPPORT_PHONE.href}>Call {SUPPORT_PHONE.display}</a>
        </Button>
      </>
    }
  />
);

export default InfoNavbar;
